/**
 * Stack of HtmlElement Objects
 *
 * @class
 */
export default class HtmlElementsStack {
  /**
   * @constructor
   *
   * @param { Object } htmlElements
   */
  constructor(...htmlElements) {
    this._stack = [];
    this.attach(...htmlElements);
  }

  // Public

  /**
   * Pushes new objects on to the stack
   *
   * @param { Object } htmlElements
   */
  attach(...htmlElements) {
    htmlElements.forEach((htmlElement) => {
      if (htmlElement.exists()) {
        this._stack.push(htmlElement);
      }
    });
  }

  /**
   * Call function by name on every element in stack if it exists
   *
   * @param { String } fnName Name of function to be called
   * @param { Object } args Potential arguments for fnName
   */
  forEachCallFunction(fnName, ...args) {
    this._stack.forEach((htmlElement) => {
      if (typeof htmlElement[fnName] === 'function') {
        htmlElement[fnName].call(htmlElement, ...args);
      }
    });
  }
}
